import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, StickyNote, X, Minus } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";

const NOTE = "bg-[#F4DC6B] text-[#2B2416] shadow-[0_8px_20px_rgba(0,0,0,0.45)]";

export const Reminders = () => {
  const [items, setItems] = useState([]);
  const [open, setOpenState] = useState(() => localStorage.getItem("reminders-open") !== "0");
  const setOpen = (v) => {
    localStorage.setItem("reminders-open", v ? "1" : "0");
    setOpenState(v);
  };
  const [adding, setAdding] = useState(false);
  const [text, setText] = useState("");
  const load = () => api.get("/reminders").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    if (!text.trim()) return;
    try {
      await api.post("/reminders", { text });
      setText("");
      setAdding(false);
      setOpen(true);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const remove = async (id) => {
    await api.delete(`/reminders/${id}`).catch(() => {});
    load();
  };

  return (
    <div className="fixed top-16 right-3 md:top-4 md:right-6 z-40 flex flex-col items-end gap-3 w-[220px]" data-testid="reminders">
      <div className="flex gap-1.5">
        <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 rounded-full border border-[#4A3B43] bg-[#161214]/90 backdrop-blur px-3 h-8 text-xs text-[#F4DC6B] hover:border-[#F4DC6B] transition-colors" data-testid="reminders-toggle">
          {open && items.length ? <Minus className="w-3.5 h-3.5" /> : <StickyNote className="w-3.5 h-3.5" />}Reminder{items.length ? ` · ${items.length}` : ""}
        </button>
        <button onClick={() => { setAdding(true); setOpen(true); }} className="flex items-center justify-center rounded-full border border-[#4A3B43] bg-[#161214]/90 w-8 h-8 text-[#F4DC6B] hover:border-[#F4DC6B] transition-colors" data-testid="reminder-add-button" aria-label="Add reminder"><Plus className="w-4 h-4" /></button>
      </div>
      {open && adding && (
        <div className={`${NOTE} w-full p-3 rotate-1`} data-testid="reminder-new">
          <textarea autoFocus rows={4} maxLength={500} value={text} onChange={(e) => setText(e.target.value)} placeholder="Note for next time…" className="w-full bg-transparent outline-none resize-none text-sm placeholder:text-[#2B2416]/50" data-testid="reminder-text-input" />
          <div className="flex justify-end gap-3 text-xs font-medium">
            <button onClick={() => setAdding(false)} data-testid="reminder-cancel">Cancel</button>
            <button onClick={save} className="underline" data-testid="reminder-save">Stick it</button>
          </div>
        </div>
      )}
      {open && items.map((r, i) => (
        <div key={r.id} className={`${NOTE} w-full p-3 pt-2 ${i % 2 ? "rotate-1" : "-rotate-1"} transition-transform hover:rotate-0`} data-testid={`reminder-${r.id}`}>
          <div className="flex justify-between items-start gap-2">
            <p className="text-[10px] opacity-60">{r.user_name} · {fmtDateTime(r.created_at)}</p>
            <button onClick={() => remove(r.id)} className="opacity-60 hover:opacity-100" data-testid={`reminder-delete-${r.id}`} aria-label="Remove reminder"><X className="w-3.5 h-3.5" /></button>
          </div>
          <p className="text-sm whitespace-pre-wrap break-words mt-1" data-testid={`reminder-text-${r.id}`}>{r.text}</p>
        </div>
      ))}
    </div>
  );
};
